const DELIMITER = '/';

// eslint-disable-next-line import/prefer-default-export
export function getAreaAndOrigin(zone) {
  return {
    geoArea: zone.split(DELIMITER)[0],
    region: zone.split(DELIMITER)[1],
  };
}

export function getZone(geoArea, region) {
  if (geoArea === '') return 'Loading...';
  return `${geoArea}${DELIMITER}${region}`;
}
